import React from "react";
import {Button, Columns, Heading, Modal, Section} from "react-bulma-components";


export default function ConfirmCollectedModal({onCollected, open, setOpen}){


    return (
        <Modal
            show={open}
            closeOnBlur
            onClose={() => setOpen(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Vehicle Collection</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <p>Does the key need unassigning?</p>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                fullwidth
                                color={"success"}
                                onClick={onCollected}
                            >
                                Collected
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                fullwidth
                                color={"info"}
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )

}